import { render, staticRenderFns } from "./CheckpointEditFormV2.vue?vue&type=template&id=0fcbca58&scoped=true"
import script from "./CheckpointEditFormV2.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointEditFormV2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointEditFormV2.vue?vue&type=style&index=0&id=0fcbca58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcbca58",
  null
  
)

export default component.exports